import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SQLEditor.module.scss';

interface SQLEditorProps {
  value: string;
  onChange: (sql: string) => void;
  onRun: () => void;
  isRunning: boolean;
  executionTimeMs?: number;
}

export const SQLEditor = forwardRef<HTMLTextAreaElement, SQLEditorProps>(({
  value,
  onChange,
  onRun,
  isRunning,
  executionTimeMs,
}, ref) => {
  const { t } = useTranslation();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
      e.preventDefault();
      onRun();
    }
  };

  return (
    <div className={styles.container}>
      <textarea
        ref={ref}
        className={styles.textarea}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={t('Enter your SQL query here...')}
        spellCheck={false}
        rows={8}
      />
      <div className={styles.toolbar}>
        <span className={styles.hint}>
          {t('Ctrl+Enter to run')}
        </span>
        {executionTimeMs !== undefined && (
          <span className={styles.timing}>
            {t('Executed in')} {executionTimeMs}ms
          </span>
        )}
        <button
          className={styles.runBtn}
          onClick={onRun}
          disabled={isRunning || !value.trim()}
        >
          {isRunning ? t('Running...') : t('Run Query')}
        </button>
      </div>
    </div>
  );
});

SQLEditor.displayName = 'SQLEditor';
